import { mapValues } from '@tunein/web-utils';
const universalAdParameters = {
    stationId: 'stationId',
    programId: 'programId',
    topicId: 'topicId',
    uploadId: 'uploadId',
    language: 'language',
    countryRegionId: 'country_region_id',
    stationLanguage: 'station_language',
    isNewUser: 'is_new_user',
    isFamily: 'is_family',
    isMature: 'is_mature',
    isEvent: 'is_event',
    isOnDemand: 'is_ondemand',
    class: 'class',
    genreId: 'genre_id',
    bandId: 'BandId',
    categoryId: 'categoryId',
    screen: 'screen',
    lotameSegments: 'lotamesegments',
    listingId: 'ListingId',
    targetingIdl: 'IDL',
    videoAdPlayed: 'videoAdPlayed',
    persona: 'persona',
    abTest: 'abtest',
    unlockEnabled: 'unlockEnabled',
    campaignId: 'campaignId',
    nflUnlocks: 'nflUnlocks',
    isUnlocked: 'isUnlocked',
    isLoggedIn: 'isLoggedIn',
    partnerId: 'partnerId',
    premium: 'premium',
    env: 'env',
    adsPartnerAlias: 'ads_partner_alias',
    affiliateIds: 'affiliateIds',
};
const gamOnlyAdsParameters = {
    usPrivacy: 'us_privacy',
};
export const adsParameters = {
    ...universalAdParameters,
    ...gamOnlyAdsParameters,
};
export const adsWizzAdParameters = mapValues(universalAdParameters, (adParam) => `aw_0_1st.${adParam}`);
